import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import List from '@/assets/common/List/List.vue'
import WarehouseDetail from '@/components/Warehouses/WarehouseDetail/WarehouseDetail.vue'
import store from '@/assets/common/store/store';

@Component({
    components: {
        List,
        WarehouseDetail
    }
})
export default class Warehouse extends Vue {
    private baseUrl = '/warehouses'
    private title = '倉庫'
    private isLoading = false
    private warehouses = []
    private selectedWarehouseId: string | null = null
    private withHidden = false

    @Prop()
    private id!: string

    @Watch("id")
    private onChangeId() {
        if (this.selectedWarehouseId !== 'create') {
            this.selectedWarehouseId = this.id
        }
    }

    created(): void {
        if (this.id) {
            this.selectedWarehouseId = this.id
        }
        this.getWarehouses()
    }

    getWarehouses(): void {
        this.isLoading = true
        this.$apiClient.doRequest('get', `${this.baseUrl}?with_hidden=${this.withHidden}`).then(ret => {
            this.warehouses = ret.warehouses
        }).finally(() => {
            this.isLoading = false
        })
    }

    createWarehouse(): void {
        this.$router.push(`/master${this.baseUrl}`, () => { return })
        if(store.getters.isInputChanged==false){
            this.selectedWarehouseId = 'create'
        }
    }
    setWarehouse(warehouseId: string): void {
        this.$router.push(`/master${this.baseUrl}/${warehouseId}`, () => { return })
        if(store.getters.isInputChanged==false){
        this.selectedWarehouseId = warehouseId
        }
    }
    checkboxChanged(b: boolean): void {
        this.withHidden = b
        this.getWarehouses()
    }
}